module.exports = "../static/media/logo_shadow.8c5a05e8.png";